import PageUsersDetail from 'hcp/components/page/users/detail';

<template>
  <PageUsersDetail
    @currentRolesLocation={{@controller.model.currentRolesLocation}}
    @currentScopeLink={{@controller.model.currentScopeLink}}
    @organization={{@controller.model.organization}}
    @organizationPolicy={{@controller.model.orgPolicy}}
    @roleLocations={{@controller.model.roleLocations}}
    @scimEnabled={{@controller.model.scimEnabled}}
    @ssoEnabled={{@controller.model.ssoEnabled}}
    @userPrincipal={{@controller.model.userPrincipal}}
  />
</template>
